import { ROUTES } from './routes';

export const LOCATION_EXCEPTIONS = [
  ROUTES.SIGN_UP,
  ROUTES.EMAIL_SENT,
  ROUTES.PROCESS_SUCCESS,
  ROUTES.CONFIRMATION,
  ROUTES.LOGIN,
  ROUTES.ACCEPTED_INVITE,
  ROUTES.JOIN_COMPANY,
  ROUTES.PASSWORD_RESET,
];
